import React, { useLayoutEffect, useMemo, useRef, useState } from "react";
import {
  UNSAFE_LocationContext as LocationContext,
  UNSAFE_NavigationContext as NavigationContext,
} from "react-router-dom";
import { createMemoryHistory } from "@remix-run/router";

/**
 * Per-tab isolated routing without nesting a <Router> inside BrowserRouter.
 * Provides the same contexts that <Router> would, using an in-memory history.
 */
export default function TabRouter({ initialEntry, children }) {
  const historyRef = useRef(null);
  if (historyRef.current == null) {
    historyRef.current = createMemoryHistory({
      initialEntries: [initialEntry],
      v5Compat: true,
    });
  }
  const history = historyRef.current;

  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  const navigationContext = useMemo(
    () => ({
      basename: "/",
      navigator: history,
      static: false,
      future: { v7_relativeSplatPath: false },
    }),
    [history]
  );

  const locationContext = useMemo(
    () => ({
      location: state.location,
      navigationType: state.action,
    }),
    [state.location, state.action]
  );

  return (
    <NavigationContext.Provider value={navigationContext}>
      <LocationContext.Provider value={locationContext}>
        {children}
      </LocationContext.Provider>
    </NavigationContext.Provider>
  );
}
